import { useEffect, useMemo, useState } from "react";
import { useAppSelector } from "../../../redux/store";
import {
  listenToDocuments,
  QueryOptions,
} from "../../../services/firestoreServices";
import { getValue } from "../../list/ListScreen";
import { AuthState } from "../../../redux/slices/authSlice";
import { Filter, WhereCondition } from "../../../config/companies/config";

export const useBoardData = (
  collectionName: string,
  where: WhereCondition[] | undefined,
  onlyCompany: boolean,
  visibleAtEnabled: boolean | undefined,
  activeFilters: Filter[],
  applyFilters: (data: any[], filters: Filter[]) => any[],
) => {
  const [rawData, setRawData] = useState<any[]>([]);
  const auth = useAppSelector((state) => state.auth);
  const timestamp = useAppSelector((state) => state.auth.timestamp);

  useEffect(() => {
    let options: QueryOptions = {
      where: [],
      onlyCompany,
    };

    if (where) {
      // Resolve `where` entries to concrete values. Optionally apply the
      // condition only for specific roles using `applyToRoles` on a WhereCondition.
      options.where = where.reduce((acc: WhereCondition[], item) => {
        const currentRole = (auth as Record<string, any>).user?.role;

        console.log("currentRole", currentRole, item.applyToRoles);
        // If this condition specifies applyToRoles and current role is not included, skip
        if (item.applyToRoles && !item.applyToRoles.includes(currentRole)) {
          return acc;
        }

        const filterValue = item.from
          ? getValue(
              (auth as Record<string, any>)[item.from],
              item.value as string,
            )
          : item.value;

        acc.push({
          ...item,
          value: filterValue,
        });

        return acc;
      }, [] as WhereCondition[]);
    }

    console.log("options:", options.where);

    const unsubscribe = listenToDocuments(
      collectionName,
      (data) => {
        if (!visibleAtEnabled) {
          setRawData(data);
          return;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const visibleData = data.filter((item) => {
          if (item.createdById === auth.user.uid) {
            return true;
          }

          const visibleAt = item.visibleAt;
          if (!visibleAt) {
            return true;
          }

          const visibleAtDate = visibleAt?.toDate
            ? visibleAt.toDate()
            : new Date(visibleAt);
          visibleAtDate.setHours(0, 0, 0, 0);

          return visibleAtDate <= today;
        });

        setRawData(visibleData);
      },
      options,
    );

    return () => {
      unsubscribe();
    };
  }, [
    auth.user.uid,
    collectionName,
    timestamp,
    onlyCompany,
    where,
    visibleAtEnabled,
  ]);

  const filteredData = useMemo(
    () => applyFilters(rawData, activeFilters),
    [rawData, activeFilters],
  );

  return { rawData, filteredData };
};
